<template>
  <div>
    <TerrorZoneNavBar />
    <Ad placementName="video_slider"/>
    <div class="my-1 home">
      <img width="300" height="300" alt="Diablo II Terror Zones" src="@/assets/D2TZ-logo.png">
      <b-button class="m-4 btn" size="lg" variant="outline-light" href="/introduction">{{ $t('nav.introduction') }}</b-button>
      <b-button class="m-4 btn" size="lg" variant="outline-light" href="/online">{{ $t('mode.onlineTZ') }}</b-button>
      <b-button class="m-4 btn" size="lg" variant="outline-light" href="/offline">{{ $t('mode.offlineTZ') }}</b-button>
      <b-button class="m-4 btn" size="lg" variant="outline-light" href="/apps">{{ $t('nav.notificationApp') }}</b-button>
      <b-button class="m-4 btn" size="lg" variant="outline-light" href="/exp">{{ $t('nav.levelupCalculator') }}</b-button>
    </div>
    <TerrorZoneFooter class="mt-4"/>
  </div>
</template>

<script>
import Ad from './components/Ad.vue'
import TerrorZoneNavBar from './components/NavBar.vue'
import TerrorZoneFooter from './components/Footer.vue'
import { supportedLanguages, parseParameters } from '@/utils/common'

export default {
  name: 'Home',

  components: {
    Ad,
    TerrorZoneNavBar,
    TerrorZoneFooter,
  },

  async created () {
    const paramStr = window.location.search;
    let showGuide = false;
    let gotoTz = false;
    let language = null;
    if (paramStr?.length > 0) {
      const params = parseParameters(paramStr);
      if (!!params['l'] && supportedLanguages.includes(params['l'])) {
        language = params['l'];
        gotoTz = true;
      }
      if (!!params['language'] && supportedLanguages.includes(params['language'])) {
        language = params['language'];
        gotoTz = true;
      }
      if (params['app_guide']) {
        showGuide = true;
      }
    }
    if (language) {
      localStorage.setItem('language', language);
      this.$i18n.locale = language;
    }
    if (showGuide) {
      window.location.href = "/apps";
    }
    else if (gotoTz) {
      window.location.href = "/online";
    }
  },
}
</script>

<style scoped>
.home {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-height: 70vh;
}
.btn-container {
    text-align: center;
}
.btn {
    min-width: 300px;
}
</style>
